// nodeQueryKeys.js

const normalizeNodeKeys = (nodeKeys = []) => (
  Array.from(new Set(
    (Array.isArray(nodeKeys) ? nodeKeys : [])
      .map((key) => String(key || '').trim())
      .filter(Boolean)
  )).sort()
);

export const nodeQueryKeys = {
  byKeys: (nodeKeys = []) => ['nodes', 'byKeys', normalizeNodeKeys(nodeKeys).join('|')],
};

export { normalizeNodeKeys as normalizeNodeKeysForQuery };
